import React, { useState } from "react";
import Heading from "../ui/Heading";
import Paragraph from "../ui/Paragraph";
import Cta from "../ui/Cta";

const FlipCard = ({ onFlip, imageUrl, children }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  return (
    <div
      onMouseOver={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
      className="flip-container overflow-clip w-full h-full rounded-xl">
      <div
        className={`relative object-cover w-full object-center h-full group cursor-pointer hover:shadow-custom-gray-v4/50 shadow-[0_0_20px_0_transparent] flip-inner ${
          isFlipped ? "flipped" : ""
        }`}>
        <img
          src={imageUrl}
          className="absolute flip-front top-0 left-0 h-full w-full object-cover group-hover:scale-105"
          onError={(e) => (e.currentTarget.style.display = "none")}
          alt="gallery content"
        />
        <div className="flip-back absolute border border-solid border-custom-blue-v2 bg-white top-0 h-full w-full p-3 rounded-xl overflow-auto">
          {/* {children} */}

          <Heading variant="secondary" className=" !text-sm sm:!text-xl">
            Lorem ipsum dolor sit amet.
          </Heading>

          <Paragraph className="mt-3 max-sm:text-xs">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias
            enim impedit deleniti labore nulla nobis blanditiis officiis alias
            assumenda veritatis.
          </Paragraph>
          <Paragraph className="my-3 max-sm:text-xs">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias
            enim impedit deleniti labore nulla nobis blanditiis officiis alias
            assumenda veritatis.
          </Paragraph>
          <Cta className="max-sm:px-3 max-sm:text-xs max-sm:py-1 mt-4">
            Reade More
          </Cta>
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
